<template>
  <div :class="['kudos-list', { 'kudos-list-selectable': selectable }]">
    <template v-if="!loading">
      <div class="kudos-list-grid">
        <kudo-item
          v-for="kudo in kudos"
          :key="kudo.id"
          :kudo="kudo"
          :count="count(kudo.id)"
          :selectable="selectable"
          :selected="selected === kudo.id"
          @click="onKudoSelect"
        >
          <template #tooltip="data">
            <slot name="tooltip" v-bind="data" />
          </template>
        </kudo-item>
      </div>
      <div v-if="!kudos.length" class="kudos-list-empty">
        <div>
          <kudos-empty />
        </div>
        <div class="mt-3">
          No kudos received… yet!
        </div>
      </div>
    </template>
    <div v-else class="text-center p-5 w-100">
      <b-spinner variant="primary" label="Loading..." />
    </div>
  </div>
</template>

<script>
import KudoItem from './KudoItem.vue'
import KudosEmpty from '@/assets/images/kudos-empty.svg'

export default {
  name: 'KudosList',

  model: {
    prop: 'selected',
    event: 'select'
  },

  props: {
    kudos: {
      type: Array,
      default: () => ([])
    },

    received: {
      type: Array,
      default: () => ([])
    },

    loading: {
      type: Boolean,
      default: false
    },

    selectable: {
      type: Boolean,
      default: false
    },

    selected: {
      type: Number,
      default: undefined
    }
  },

  methods: {
    count(id) {
      const kudo = this.received.find(p => p.kudo === id)
      return (kudo || {}).count
    },

    onKudoSelect(id) {
      this.$emit('select', id)
    }
  },

  components: {
    KudoItem,
    KudosEmpty
  }
}
</script>
